import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import { fb, gapi, signOutFacebook, signOutGoogle } from 'auth';
// import FacebookLoginButton from 'FacebookLoginButton';
import GoogleLoginButton from 'GoogleLoginButton';
import { useRecoilState, useRecoilValue } from 'recoil';

import {
  isSignInModalOpenAtom,
  selectUserProfile,
} from 'state/signInRecoilState';

function SignInModal() {
  const userProfile = useRecoilValue(selectUserProfile);
  const [isSignInModalOpen, setIsSignInModalOpen] = useRecoilState(
    isSignInModalOpenAtom
  );

  const closeModal = () => setIsSignInModalOpen(false);

  const onGoogleFailure = () => {
    alert('Google Sign In Failed');
  };

  const onSignOut = () => {
    signOutGoogle();
    signOutFacebook();
  };

  const onEntered = () => {
    try {
      gapi()?.signin2.render('my-signin2', {
        onfailure: onGoogleFailure,
      });
      fb()?.XFBML.parse();
    } catch (error) {}
  };

  return (
    <Dialog
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={isSignInModalOpen}
      onClose={closeModal}
      TransitionProps={{ onEntered }}
    >
      <DialogTitle>Account</DialogTitle>

      <DialogContent>
        <Grid container spacing={2}>
          <Grid item>
            <Box
              component="div"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: 240,
                width: 400,
              }}
            >
              {userProfile ? (
                <>
                  <Typography>
                    You are signed in with {userProfile.type} as
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'row', mt: 2 }}>
                    <Box sx={{ mr: 2 }}>{/* <UserAvatar /> */}</Box>
                    {userProfile?.name}
                  </Box>
                </>
              ) : (
                <>
                  <Typography>
                    Sign in to be able to access boards on other devices
                  </Typography>

                  <br />
                  <GoogleLoginButton />
                  <br />
                  {/* <FacebookLoginButton /> */}
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={closeModal} color="primary">
          Close
        </Button>
        {userProfile && (
          <Button onClick={onSignOut} color="primary">
            Sign Out
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default SignInModal;
